// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { availabilityStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsAvailability";
import { IconWrapper } from "@insite/mobius/Icon";
import { fontConfig } from "@plumberssupply/XDL/PreStyle/typography";
import { xScreen } from "@plumberssupply/XDL/Utilities";
import { css } from "styled-components";

availabilityStyles.availability = {
    availabilityByWarehouseLink: {
        typographyProps: {
            size: 16,
            css: css`
                line-height: 26px;
                ${xScreen("lte", "md")}{
                    font-size: 14px;
                    line-height: 22px;
                }
            `,
        },
        css: css`
            margin-left: 20px;
        `,
    },
    messageText: {
        size: 16,
        css: css`
            font-weight: ${fontConfig.weight.extraBold};
            line-height: 26px;
            &[data-test-selector="availabilityMessageWarehouse"] {
                font-size: 12px;
                line-height: 15px;
                font-weight: ${fontConfig.weight.regular};
                ${xScreen("gt", "md")}{
                    &&&&& {
                        margin-bottom: 4px !important;
                    }
                }
                ${xScreen("lte", "md")}{
                    font-size: 14px;
                    line-height: 22px;
                    font-weight: ${fontConfig.weight.bold};
                }
            }
            ${xScreen("lte", "md")}{
                font-size: 14px;
                line-height: 22px;
                font-weight: ${fontConfig.weight.extraBold};
            }
        `,
    },
    container: {
        css: css`
            ${xScreen("lte", "md")}{
                margin-top: 8px;
            }
            &&& {
                div[class^="InventoryMessage"] {
                        ${IconWrapper}, svg {
                            width: 16px;
                            height: 16px;
                        }
                }
            }

        `,
    },
};